import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { pickContextTypes } from '../../context-types';

import Icon from 'widget/player-widget/components/icon/icon';
import ControlButton from '../../control-button/control-button';

import styles from './play.styl';


@WixConnect(styles)
export default class Play extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
  };

  static contextTypes = pickContextTypes('togglePause', 'paused', 'fullScreen');

  get iconName() {
    return this.context.paused ? 'play' : 'pause';
  }

  @autobind
  togglePause() {
    const { paused, togglePause } = this.context;
    togglePause(!paused);
  }

  render() {
    const { className } = this.props;
    const { fullScreen } = this.context;

    const iconName = this.iconName;
    const styleNames = classnames('play', `play--${iconName}`, {
      'at-full-screen': fullScreen,
    });

    return (
      <ControlButton styleName={styleNames}
                     className={className}
                     onClick={this.togglePause}>
        <Icon styleName="icon"
              name={iconName} />
      </ControlButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/play/play.js